// components/Hero.jsx
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative h-[85vh] flex items-center justify-center bg-[#2D033B] bg-cover">
      {/* Optional overlay if you add a background image later */}
      {/* <div className="absolute inset-0 bg-[#2D033B]/70" /> */}

      <div className="relative z-10 max-w-5xl px-6 text-center text-white">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-6 animate-fadeInDown">
          Restoring Lives and Transforming Communities <br />
          Through Faith, Love, and Service
        </h1>

        <p className="text-lg md:text-xl mb-8 animate-fadeInUp delay-300 text-[#EDE4F7]">
          Queen Esther’s Impact Foundation is a faith-driven nonprofit committed to
          restoring lives, empowering individuals, and supporting vulnerable
          communities through compassion, service, and purposeful impact.
        </p>

        <div className="flex flex-wrap justify-center gap-4 animate-fadeInUp delay-500">
          <Link
            to="/donate"
            className="bg-[#6A0DAD] px-8 py-3 rounded-md text-lg font-semibold text-white hover:bg-[#5F0F99] transition-all"
          >
            Donate Now
          </Link>

          <Link
            to="/get-involved"
            className="border border-white/80 px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:text-[#6A0DAD] transition"
          >
            Become a Volunteer
          </Link>
        </div>
      </div>
    </section>
  );
}
